/**
 * src/modules/dashboard/componentes/assuntoprodutos.js
 * -----------------------------------------------------------------------------
 * Componente público para exibição de principais assuntos por produto.
 * - Recebe dados por props.
 * - Exibe filtros aplicados no topo.
 * - Usa GraficoHeatmapProduto com configuração específica para produtos.
 */





import React from 'react';
import './assuntoprodutos.scss';
import { GraficoHeatmapProduto } from '../../../components/graficos/heatmapproduto';

function HeatmapBox({
  categoriaId,
  descricaoCategoria,
  listaDeIndicadoresProdutos,
  semdadosparaexibir
}) {
  return (
    <div
      id={`graficos-chart-box-${categoriaId}`}
      className="box-indicadores-graficos box-content heatmap-wrap"
    >
      <div className="graficos-chart-box-action-title">
        <h3>{descricaoCategoria}</h3>
      </div>

      <GraficoHeatmapProduto
        id={categoriaId}
        grafico={listaDeIndicadoresProdutos || []}
        semdadosparaexibir={semdadosparaexibir}
        hint={true}
        customHint={true}
        // 👇 Configuração específica para produtos
        tag={{ lista: 'listaDeProdutosIndicador', descricao: 'descricaoIndicador' }}
      />
    </div>
  );
}

export default function AssuntoProdutos({
  title,
  escopo,
  items = [],
  nls = {},          // ← nls global (para "filtrosAplicados")
  componentNls = {}, // ← nls do tópico (para "semdadosparaexibir")
  autor,
  filtros = [],       // ← filtros aplicados
  totaldata
}) {
  const t = {
    semdadosparaexibir: componentNls?.semdadosparaexibir || nls?.semdadosparaexibir || 'Sem dados para exibir',
    periodo: componentNls?.periodo || nls?.periodo || 'Período'
  };

  return (
    <>
    <section className="box-indicadores box-content-like">
      {/* ✅ BLOCO DE FILTROS APLICADOS — IDÊNTICO AOS DEMAIS */}
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Conteúdo principal */}
      {items.length === 0 ? (
        <div className="companyind-empty">{t.semdadosparaexibir}</div>
      ) : (
        items.map((g) => (
          <HeatmapBox
            key={g.categoriaId}
            categoriaId={g.categoriaId}
            descricaoCategoria={g.descricaoCategoria}
            listaDeIndicadoresProdutos={g.listaDeIndicadoresProdutos}
            semdadosparaexibir={t.semdadosparaexibir}
          />
        ))
      )}
    </section>
    {totaldata !== null && totaldata !== undefined && (
      <div className="feedback-totaldata-outside">
        {nls?.numerodefeedbacks}: <strong>{totaldata}</strong>
      </div>
    )}
  </>
  );
}


/*
JSON INPUT:


{
      "nls": {
        
        "semdadosparaexibir": "No data"
      },
      "label": "Principais assuntos produtos",
      "scope": {
        "periodo": {
          "fim": "2025-08-31",
          "ini": "2025-08-01"
        },
        "projetoId": 24,
        "sobreAssunto": "produtos"
      },
      "params": {
        "grupo": "celular",
        "idiomaId": 1,
        "categoriaId": 2   //NÃO É OBRIGATÓRIO
      },
      "Filtros": [
        {
          "nomedofiltro": "Grupo",
          "valordofiltro": "celular"
        },
        {
          "nomedofiltro": "Categoria",
          "valordofiltro": "Produto"
        },
        {
          "nomedofiltro": "Assunto",
          "valordofiltro": "produtos"
        }
      ],
      "ordinal": 6,
      "topicKey": "assuntoprodutos"
    }


*/
